/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../lib/primitives.js";
import { safeParse } from "../lib/schemas.js";
import { Result as SafeParseResult } from "../types/fp.js";
import {
  DecentralizationSubScore,
  DecentralizationSubScore$inboundSchema,
  DecentralizationSubScore$Outbound,
  DecentralizationSubScore$outboundSchema,
} from "./decentralizationsubscore.js";
import { SDKValidationError } from "./errors/sdkvalidationerror.js";

export type DecentralizationScore = {
  /**
   * Nakamoto Sub Percentages
   */
  nakamotoSubPercentages?: DecentralizationSubScore | undefined;
  /**
   * Nakamoto Sub Coefficients
   */
  nakamotoSubCoefficients?: DecentralizationSubScore | undefined;
  /**
   * Nakamoto Percentage Overall
   */
  nakamotoPercentageOverall?: string | undefined;
  /**
   * Nakamoto Coefficient Overall
   */
  nakamotoCoefficientOverall?: string | undefined;
};

/** @internal */
export const DecentralizationScore$inboundSchema: z.ZodType<
  DecentralizationScore,
  z.ZodTypeDef,
  unknown
> = z.object({
  nakamoto_sub_percentages: DecentralizationSubScore$inboundSchema.optional(),
  nakamoto_sub_coefficients: DecentralizationSubScore$inboundSchema.optional(),
  nakamoto_percentage_overall: z.string().optional(),
  nakamoto_coefficient_overall: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "nakamoto_sub_percentages": "nakamotoSubPercentages",
    "nakamoto_sub_coefficients": "nakamotoSubCoefficients",
    "nakamoto_percentage_overall": "nakamotoPercentageOverall",
    "nakamoto_coefficient_overall": "nakamotoCoefficientOverall",
  });
});

/** @internal */
export type DecentralizationScore$Outbound = {
  nakamoto_sub_percentages?: DecentralizationSubScore$Outbound | undefined;
  nakamoto_sub_coefficients?: DecentralizationSubScore$Outbound | undefined;
  nakamoto_percentage_overall?: string | undefined;
  nakamoto_coefficient_overall?: string | undefined;
};

/** @internal */
export const DecentralizationScore$outboundSchema: z.ZodType<
  DecentralizationScore$Outbound,
  z.ZodTypeDef,
  DecentralizationScore
> = z.object({
  nakamotoSubPercentages: DecentralizationSubScore$outboundSchema.optional(),
  nakamotoSubCoefficients: DecentralizationSubScore$outboundSchema.optional(),
  nakamotoPercentageOverall: z.string().optional(),
  nakamotoCoefficientOverall: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    nakamotoSubPercentages: "nakamoto_sub_percentages",
    nakamotoSubCoefficients: "nakamoto_sub_coefficients",
    nakamotoPercentageOverall: "nakamoto_percentage_overall",
    nakamotoCoefficientOverall: "nakamoto_coefficient_overall",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace DecentralizationScore$ {
  /** @deprecated use `DecentralizationScore$inboundSchema` instead. */
  export const inboundSchema = DecentralizationScore$inboundSchema;
  /** @deprecated use `DecentralizationScore$outboundSchema` instead. */
  export const outboundSchema = DecentralizationScore$outboundSchema;
  /** @deprecated use `DecentralizationScore$Outbound` instead. */
  export type Outbound = DecentralizationScore$Outbound;
}

export function decentralizationScoreToJSON(
  decentralizationScore: DecentralizationScore,
): string {
  return JSON.stringify(
    DecentralizationScore$outboundSchema.parse(decentralizationScore),
  );
}

export function decentralizationScoreFromJSON(
  jsonString: string,
): SafeParseResult<DecentralizationScore, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DecentralizationScore$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DecentralizationScore' from JSON`,
  );
}
